import { useQuery } from '@hooks/reactQuery';

import { getPortalTimelineMilestonesForFilter } from '@api/portalTimeline';

import { extractQueryParams } from '@utils/common';
import { portalAvailableMilestonesFormatted } from '@utils/formatter';

import { IPortalAvailableMilestonesDTO } from '@interfaces/portal/dto/taskManagementDTO';

import { refetchOptions } from '@constants/common';
import { GET_PORTAL_TIMELINE_MILESTONES_FILTER } from '@constants/queryKeys';

interface IUseQueryTimelineMilestonesReturned {
	isLoadingPortalTimelineMilestonesFilter: boolean;
	portalTimelineMilestonesFilter: IPortalAvailableMilestonesDTO[];
}

export const useQueryPortalTimelineMilestonesFilter = (projectId?: string): IUseQueryTimelineMilestonesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<IPortalAvailableMilestonesDTO[]>({
			queryKey: [GET_PORTAL_TIMELINE_MILESTONES_FILTER, projectId],
			queryFn: extractQueryParams(getPortalTimelineMilestonesForFilter),
			select: milestones => portalAvailableMilestonesFormatted(milestones),
			enabled: [!!projectId],
			...refetchOptions,
		},
	);

	return {
		isLoadingPortalTimelineMilestonesFilter: isLoading || isFetching,
		portalTimelineMilestonesFilter: data || [],
	};
};
